<template>
    <div class="app">
        <Loading :value="loading"></Loading>

          <v-dialog v-model="dialogAjoutCarteTransfert" max-width="60%" persistent :overlay="true" scrollable>
      <v-card >
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
              <span  > Effectuer un transfert </span>
              <!-- <span v-else >Modifier un rechargement  </span> -->
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

          <v-card-text>
            <el-form id="formRecharge"  :model="formRecharge" :rules="rules" ref="formRecharge" label-width="120px">
             
                <v-layout row >
                     <v-flex  xs6   >
                        <el-form-item label="Carte à crediter"   style="width:100%" prop="carte"  >
                            <el-select @change="infoCarteCible" filterable clearable v-model="formRecharge.carteCibleId"  placeholder="Selectionner une carte" >
                                <el-option v-for="item in comboCarteCible" :key="item.carteId" :label="item.identifiant" :value="item.carteId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </v-flex>
                     <v-flex xs1 class="ml-1">
                         <el-popover
                                placement="top-end"
                                width="350"
                                trigger="hover"
                                title="Info carte"
                                >
                                <el-table :data="dataCarteCible">
                                    <el-table-column width="200" property="responsable" label="Responsable"></el-table-column>
                                    <el-table-column width="150" property="solde" label="solde(Fcfa)"></el-table-column>
                                </el-table>
                                <el-button type="text"  icon="el-icon-info" slot="reference"></el-button>
                            </el-popover>
                           
                    </v-flex>
                     <v-flex xs6  class="ml-1" >  
                            <el-form-item label="Montant" prop="montant">
                                <el-input-number  :min="0"  v-model="formRecharge.montant" name="montant" placeholder="saisir un montant"  style="width: 100%"></el-input-number>
                            </el-form-item>
                      </v-flex>
                </v-layout>

                 <v-layout row>
                       <v-flex xs12 class="ml-1" >
                            <el-form-item label="Description" prop="description">
                                <el-input type="textarea" :row="25"   v-model="formRecharge.description" name="description" placeholder="description"  style="width: 100%"></el-input>
                            </el-form-item>
                        </v-flex>
                </v-layout>
                <v-layout row class="text-xs-right">
                    <v-flex  xs12 >
                        <el-form-item  class="text-xs-right" >
                            <v-btn color="grey"  @click="resetForm('formRecharge')" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                            <v-btn  icons dark color="green" @click="submitForm('formRecharge')">Enregistrer<v-icon right>add</v-icon></v-btn>
                            <!-- <v-btn v-else  icons dark color="green" @click="submitForm('formRgt')">Modifier<v-icon right>edit</v-icon></v-btn> -->
                        </el-form-item>
                    </v-flex>
                </v-layout>
            </el-form>
    
        </v-card-text>

      </v-card>
    </v-dialog>
    
    </div>
</template>
<script>

    
    import Loading from '@/components/Loading'
    export default {
        components:{ Loading },
        name: "AjoutTransfertCarte",
        props: {
            show:{
                type: Boolean,
                required: true
            },
            editRecharge: {
                type: Object,
                default:{},
                
            },
             carte: {
                type: Object,
                required: true 
            },
        
        },
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,
                // racourcis: [
                //     { path: '/', text: 'Accueil', disabled: false },
                //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
                // ],

                dialogAjoutCarteTransfert: false,
                 rules: {
                     montant: [
                        { required: true, message: 'Veuillez saisir un montant' },
                    ],
                    
                 },
                comboChantier:[],
                comboMission:[],
                formRecharge:{
                    carteCibleId:""
                },
                typeRecharge: 'Cash',
                dataCarteSource: [],
                dataCarteCible: [],
                stations:[],
                comboCarteSource:[],
                comboCarteCible:[],
                carteSourceId: "",
                carteCibleId: "",
                dateRecharge : ''
                
               
               
            }
        },

        watch:{
            show: function(newValue,oldValue){
                this.dialogAjoutCarteTransfert = newValue;
                
              

                 if(newValue == true){
                    this.resetForm('formRecharge');
                     this.loadCartes();
                 }
               

               if(this.editRecharge.id != null && newValue == true ){
                   console.log("editRecharge");
                   console.log(this.editRecharge)

                    this.formRecharge.montant = this.editRecharge.montant;
                    this.formRecharge.description = this.editRecharge.description;
                    this.dateRecharge = this.editRecharge.dateRechargeNonFormat;

                   if(this.editRecharge.type == "Transfert de carte à carte")
                   {
                       this.typeRecharge = "Carte";

                   }
                   if(this.editRecharge.type == "Cash")
                   {
                       this.typeRecharge = "Cash";
                      
                   }
                   

               }

              
                 
                

            
            }
        },

        methods: {

            infoCarteCible(idCarte){
                console.log("info carte")
                console.log(idCarte)
                if(idCarte != null){
                    this.loadInfoCarte(idCarte, 1)
                }
                 
            },

             loadInfoCarte(idCarte,source = 0){
              
                this.loading = true;
                 //this.dataCarteSource.splice(0)
                this.dataCarteCible.splice(0)
                let url = this.domaine +  'carteCarburant/carte/'+idCarte
                this.$http.get(url).then(response => {
                        this.loading = false;
                        let carte = response.body.carte[0];
                        
                    if(source == 0)
                    {
                         this.dataCarteSource.push({responsable:carte.responsable, solde:carte.montantFormat });
                    }
                    else if(source ==1)
                    {
                         this.dataCarteCible.push({responsable:carte.responsable, solde:carte.montantFormat });
                    }
                       
                        
                },
                 error=> {
                     this.loading = false;
                    this.$message("Chargement des informations de la carte en cours")
                })

                //  this.comboCarteCible = this.comboCarteSource.filter(function (item) {
                //   return (item.carteId != idCarte )
                // })
            },

            loadCarteCible(idCarte){
                console.log("loadCarteCible")
                console.log(idCarte)
                this.loading = true;
                this.loadInfoCarte(idCarte)
                this.comboCarteCible = this.comboCarteSource.filter(function (item) {
                return (item.carteId != idCarte )
            })
            },

            loadCartes(){
                console.log("changes")
                this.loading = true;
                //let url = this.domaine +  'carteCarburant/carte/station/'+carte.carteId
                let url = this.domaine +  'carteCarburant/index'
                var formdata = new FormData();
                this.$http.get(url).then(response => {
                        this.loading = false;
                        let carte = this.carte
                        console.log("cartes")
                        console.log(response.body.cartes)
                        this.comboCarteCible = response.body.cartes.filter(function(item){
                            return item.carteId !=  carte.carteId
                        })
                },
                 error=> {
                     this.loading = false;
                    this.$message("Chargement de la liste des cartes en cours")
                })
            },
           

         
            closeDialog(){
                this.$emit("close");
            },

          

            // loadStation()
            // {
            //     let url = this.domaine +  'carteCarburant/station/index'
            //     var formdata = new FormData();
           
            //     this.$http.get(url).then(response => {
                    
            //             this.stations = response.body.stations
                    
            //     },
            //      error=> {
            //         this.$message("Chargement de la liste des stations en cours")
            //     })
            // },


            submitForm(formName) 
            {
                  //verifions si la carte a ete selection
                    if(this.formRecharge.carteCibleId == ""){
                        this.$message.error("Veuillez selectionner une carte")
                        return
                    }
                this.$refs[formName].validate((valid) => {
                if (valid) 
                {
                  
                 //this.loading = true
                 let form = document.getElementById("formRecharge")
                 //recuperation des demandes
                 let data = new FormData(form);
                 let url = this.domaine + 'carteCarburant/recharge/create';
                 console.log("Recharge")
                 console.log(this.editRecharge)

                 data.append("userId",this.user.id)
                 data.append("montant",this.formRecharge.montant)
                 data.append("carteId",this.carte.carteId)
                 data.append("dateRecharge",this.dateRecharge)
                 data.append("carteSourceId",this.carte.carteId)
                 data.append("carteCibleId",this.formRecharge.carteCibleId)

                 this.$http.post(url, data).then(response => {
                     //reinitialiser le formulaire
                     this.loading = false
                     let code = response.body.code
                     this.carteCibleId = ''
                     this.carteSourceId = ''
                     this.resetForm('formRecharge')
                     this.formRecharge.description = ''
                     if(code == 1){
                          this.successNotif(response.body.message,"ENREGISTREMENT RECHARGE", "error")
                     }
                     else {
                          this.successNotif(response.body.message,"ENREGISTREMENT RECHARGE")
                     }
                    
                     this.closeDialog()
                     
                },
                (erreur) => {
                    //reinitialiser le formulaire
                    this.loading = false
                    this.resetForm('formRecharge')
                    this.formRecharge.description = ''
                    this.closeDialog()
                    this.$message.error("Une erreur est survenue lors de l'enregistrement du règlement")
                })
            } 
            });
            },

             resetForm(formName) {
                console.log("resetForm")
                this.$refs[formName].resetFields();
            },

            successNotif(mess = "", title="ENREGISTREMENT REUSSI", type="success")
            {
                this.$notify({
                        title: title,
                        message: mess,
                        type: type,
                        position: 'top-center',
                        duration: 15000
                })
            },
        },

        mounted() 
        {
         //this.loadStation();
         
        }
    };
</script>

<style scoped>
    .toolbar_content {
        height:37px; 
    }
</style>



// WEBPACK FOOTER //
// src/components/carteCarburant/AjoutTransfertCarte.vue